import React from 'react';
import { State } from '@sqior/js/state';

export const StateContext = React.createContext(new State());
